import { Message } from '@/shared/interfaces/Message'
import { ChatsStore } from '../ChatsStore'
import { decryptIncomingMessage } from '@/shared/crypto/secretMessage'

/**
 * Разнести правленое сообщение по всем местам, где лежит его прежний текст:
 * открытая переписка, кэш переписки (в том числе закрытого чата — из него
 * переписка поднимается при возврате) и последнее сообщение в списке чатов.
 *
 * Сообщение секретного чата приходит конвертом — расшифровываем копию здесь.
 * Возвращает то, что подставлено (уже расшифрованное).
 */
export async function chatsApplyEditedMessage(chatId: number, message: Message): Promise<Message> {
  const { chatsStore, chatsState } = ChatsStore.get()

  const chat = chatsState.chats.find((item) => item?.id === chatId)
    || (chatsState.selectedChat?.id === chatId ? chatsState.selectedChat : undefined)

  const updated = { ...message } as Message
  if (chat?.is_secret && chat.user?.id) {
    await decryptIncomingMessage(chat.user.id, updated)
  }

  if (chatsState.selectedChat?.id === chatId) {
    chatsState.messageGroups.forEach((group) => {
      const index = group.messages.findIndex((item) => item.id === updated.id)
      if (index !== -1) {
        group.messages[index] = updated
      }
    })
    chatsStore.cacheCurrentChatMessages()
  } else {
    chatsStore.updateCacheForChat(chatId, (cached) => {
      cached.messageGroups.forEach((group) => {
        const index = group.messages.findIndex((item) => item.id === updated.id)
        if (index !== -1) {
          group.messages[index] = JSON.parse(JSON.stringify(updated))
        }
      })
    })
  }

  // Список чатов следит за сменой объекта последнего сообщения, а не за его
  // полями — подставляем новый объект, иначе в списке остаётся текст до правки.
  if (chat?.last_message?.id === updated.id) {
    chat.last_message = { ...updated }
  }

  return updated
}
